const fetchTechnicianUsecase = (repository) => async (pagination, search, status) => {
    const payload = {
        sort: pagination.sortBy.map((s) => [s]).join(','),
        descending: pagination.sortDesc.join(','),
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
        search: search,
        status: status
    }
    return await repository(payload);
}

export default fetchTechnicianUsecase;